const seniorityOptions = [
  { value: 1, label: 'Junior' },
  { value: 2, label: 'Mid level' },
  { value: 3, label: 'Senior' },
  { value: 4, label: 'Managment' },
];

export default seniorityOptions;
